// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8194) return "static/chunks/8194-19c20353c31c9956.js";
	if (chunkId === 3016) return "static/chunks/3016-17c0cab9721fc7df.js";
	if (chunkId === 7123) return "static/chunks/7123-53929f4192466852.js";
	if (chunkId === 3327) return "static/chunks/3327-e036bf26587652b4.js";
	if (chunkId === 851) return "static/chunks/851-ed94200f39cc0a2c.js";
	if (chunkId === 2293) return "static/chunks/2293-ebec3baddfcdbf72.js";
	if (chunkId === 2464) return "static/chunks/2464-696098cce17883d2.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"4164":"378efcd1","6892":"74c44f4a"}[chunkId] || chunkId) + "." + {"411":"b1fe68ba5150e8b7","2250":"32ae2e34f66b37d3","4164":"d503587bd8e8c0e5","4552":"e8da8fed7bc45fb2","5398":"810947dd86da8a26","5432":"2e128b18a073ce64","6892":"986d6c13fea1f015","7183":"fd7e12141bc28fe3","8290":"cc36bf5fa135a601","8839":"0fd54808452924b9","9399":"f1680a666d18d129"}[chunkId] + ".js";
};